let observerStarted = false;

function initializeScript() {
    startObserver();
    moveSection();
}

// Initial page load
window.addEventListener("load", initializeScript);

// Browser back/forward cache restore
window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
        console.log("Page restored from back-forward cache");
        initializeScript();
    }
});

function waitForElement(selector, callback, timeout = 10000) {
    const interval = 300;
    let elapsed = 0;

    const timer = setInterval(() => {
        const el = document.querySelector(selector);

        if (el) {
            clearInterval(timer);
            callback(el);
            return;
        }

        elapsed += interval;

        if (elapsed >= timeout) {
            clearInterval(timer);
            console.warn(selector + " not found within timeout");
        }
    }, interval);
}

function startObserver() {
    if (observerStarted) return;

    observerStarted = true;

    const observer = new MutationObserver(() => {
        moveSection();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

function createButton() {
    const button = document.createElement("button");

    button.id = "custom-button";
    button.textContent = "Tier Details";

    button.addEventListener("click", (e) => {
        e.preventDefault();

        const target = document.querySelector(".loyalty-tier-table");

        if (target) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    });

    return button;
}

function moveSection() {
    const targetContainer = document.querySelector(
        "div#oke-loyalty-profile .c-card--customisable.c-promptProgressCard"
    );

    if (!targetContainer) return;

    // Button already exists in the correct location
    if (targetContainer.querySelector("#custom-button")) {
        return;
    }

    let button = document.querySelector("#custom-button");

    if (!button) {
        button = createButton();
    }

    targetContainer.appendChild(button);
}